"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgNum = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const FormRow_1 = require("../../../../3-list-item/FormRow");
const css_1 = require("./css");
const InputNumber_1 = require("../../../../2-inline-block/InputNumber");
const ArgNumCompact_1 = require("./ArgNumCompact");
const unwrapNum = (v) => {
    if (v && typeof v === 'object' && 'value' in v)
        return Number(v.value) || 0;
    return Number(v) || 0;
};
const ArgNum = (props) => {
    if (props.compact)
        return React.createElement(ArgNumCompact_1.ArgNumCompact, { ...props });
    const { param, value, onChange, compact: _compact, ...rest } = props;
    return (React.createElement("div", { className: css_1.argBlockCss },
        React.createElement(FormRow_1.FormRow, { title: param.display?.() ?? param.name ?? param.id, optional: param.optional },
            React.createElement(InputNumber_1.InputNumber, { ...rest, value: unwrapNum(value), onChange: (txt) => {
                    const num = Number(txt);
                    if (!Number.isNaN(num))
                        onChange(num);
                } }))));
};
exports.ArgNum = ArgNum;
